module.exports = __webpack_public_path__ + "img/fullscreen.62d883f8.svg";